import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { SUBJECT_DIALOG_MESSAGES, SubjectDialogMessages } from "./subject-dialog.messages";
import { SUBJECT_FORM_MESSAGES, SubjectFormMessages } from "./subject-form.messages";
import { SUBJECT_REQUEST_MESSAGES, SubjectRequestMessages } from "./subject-request.messages";
import { SUBJECT_TABLE_MESSAGES, SubjectTableMessages } from "./subject-table.messages";

export type SubjectMessages = ActionButtonMessages &
  SidebarMessages &
  PopoverMessages &
  SubjectFormMessages &
  SubjectRequestMessages &
  SubjectTableMessages &
  SubjectDialogMessages & {
    pageTitle: string;
    breadCrumbTitle: string;
    createPageTitle: string;
    updatePageTitle: string;
    viewPageTitle: string;
    subjectTableTitle: string;
    addSubjectButton: string;
  };

export const SUBJECT_MESSAGES: SubjectMessages = {
  pageTitle: "Assuntos",
  createPageTitle: "Criar Assunto",
  updatePageTitle: "Editar Assunto",
  viewPageTitle: "Visualizar Assunto",
  subjectTableTitle: "Listagem de Assuntos",
  breadCrumbTitle: "Assuntos",
  addSubjectButton: "Novo Assunto +",

  ...SUBJECT_DIALOG_MESSAGES,
  ...SUBJECT_TABLE_MESSAGES,
  ...SUBJECT_REQUEST_MESSAGES,
  ...SUBJECT_FORM_MESSAGES,

  ...POPOVER_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
};
